import React from 'react';
import { useDispatch } from 'react-redux';

import { setNotification } from 'state/app.state';

interface CopyToClipboardProps {
  children: React.ReactElement;
  text?: string;
  component?: React.ElementType;
}

const CopyToClipboard = ({ text = '', children, component = 'div' }: CopyToClipboardProps) => {
  const dispatch = useDispatch();
  const Component: React.ElementType = component;

  const copyText = () => {
    // navigator may not always have the clipboard property, need to prevent TypeScript from failing
    const navigator = window.navigator as any;

    // do we have the clipboard API?
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      if (!text) {
        dispatch(setNotification({ type: 'error', text: 'No text to copy' }));
      } else {
        navigator.clipboard.writeText(text).then(
          () => dispatch(setNotification({ type: 'success', text: 'Text copied' })),
          () => dispatch(setNotification({ type: 'error', text: 'Could not copy text' }))
        );
      }
    } else {
      dispatch(setNotification({ type: 'error', text: 'Could not copy text' }));
    }
  };

  return <Component>{React.cloneElement(children, { onClick: copyText })}</Component>;
};

export default CopyToClipboard;
